import { map as rxjsmap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class CustomizeHomePageService {
  constructor(private http: HttpClient) {}

  add(data) {
    return this.http
      .post(environment.BASE_URL + '/homepages/homepage', data).pipe(rxjsmap(result => result));
  }

  update(data) {
    return this.http
      .put(environment.BASE_URL + '/homepages/homepageupdate', data).pipe(rxjsmap(result => result));
  }

  getData(applicationId: number, typeId: number, createdBy: number) {
    return this.http
      .get<any>(
        environment.BASE_URL +
          '/homepages/homepagelistbyapplication/' +
          applicationId +
          '/' +
          typeId +
          '/' +
          createdBy
      ).pipe(rxjsmap(result => result));
  }
}
